import { render, staticRenderFns } from "./veJkyProjectMy.vue?vue&type=template&id=63da751c&scoped=true"
import script from "./veJkyProjectMy.vue?vue&type=script&lang=js"
export * from "./veJkyProjectMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63da751c",
  null
  
)

export default component.exports